/**
 * 本地静态路由数据配置，该配置由开发人员维护
 * 路由菜单配置，数据格式必须遵循一下规则，否则请自定义修改
 * I18n title message.menu.home
 * **** true false 也可以用 0 和 1 代替，必须为数值或者boolean ****
 * path          必填 请求路径
 * component     必填 组件路径，默认在pages/目录下，但不用填写pages/
 * auth          必填 是否授权登录可访问 默认true
 * isKeepAlive   是否缓存组件状态 默认true
 *
 * icon         菜单、tagsView 图标，阿里：加 `iconfont xxx`，fontawesome：加 `fa xxx`
 * title        必填 菜单栏及 tagsView 栏、菜单搜索名称（国际化）
 * type         菜单类型 1菜单 2目录
 * sort         排序 默认1
 * isHide       是否隐藏，当前菜单 默认false
 * isDisable    是否禁用 默认false
 * isLink       是否超链接菜单与 isIframe 互斥 默认false
 * isIframe     是否内嵌窗口与 isLink 互斥 默认false
 * address      当 isLink isIframe两者为true时此项必填 默认
 *
 * isAffix      是否固定在 tagsView 栏上 默认true
 * isMobile     是否为手机端 默认false
 * roles        判断是否有当前角色，仅仅当前端控制权限时，此项必须，不建议前端去搞这玩意
 * permission   当前操作权限[C,R,U,D]
 * children
 */
export default [
  {
    id: 1,
    path: "dashboard",
    component: "inv/Dashboard",
    type: 1,
    title: "工作台",
    icon: "icon-home",
    auth: 1,
    isLink: 0,
    isIframe: 0,
    address: "",
    isHide: 0,
    isAffix: 1,
    isKeepAlive: 1,
    isDisable: 0,
    isMobile: 0,
    roles: ["admin", "system"],
    permission: ["C", "R", "U", "D"],
    children: [],
  },
  {
    id: 10,
    path: "basic",
    component: "layout/Index",
    type: 2,
    title: "基础资料",
    icon: "icon-setting",
    auth: 1,
    isLink: 0,
    isIframe: 0,
    address: "",
    isAffix: 0,
    isKeepAlive: 0,
    isDisable: 0,
    isHide: 0,
    isMobile: 0,
    roles: ["admin", "system"],
    permission: ["C", "R", "U", "D"],
    children: [
      {
        id: 11,
        path: "products",
        component: "inv/basic/Products",
        type: 1,
        title: "商品管理",
        icon: "icon-font",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
      {
        id: 12,
        path: "warehouses",
        component: "inv/basic/Warehouses",
        type: 1,
        title: "仓库管理",
        icon: "icon-home",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
      {
        id: 13,
        path: "customers",
        component: "inv/basic/Customers",
        type: 1,
        title: "客户管理",
        icon: "icon-user",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
      {
        id: 14,
        path: "suppliers",
        component: "inv/basic/Suppliers",
        type: 1,
        title: "供应商管理",
        icon: "icon-user",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
    ],
  },
  {
    id: 20,
    path: "purchase",
    component: "layout/Index",
    type: 2,
    title: "采购管理",
    icon: "icon-home",
    auth: 1,
    isLink: 0,
    isIframe: 0,
    address: "",
    isAffix: 0,
    isKeepAlive: 0,
    isDisable: 0,
    isHide: 0,
    isMobile: 0,
    roles: ["admin", "system"],
    permission: ["C", "R", "U", "D"],
    children: [
      {
        id: 21,
        path: "orders",
        component: "inv/purchase/Orders",
        type: 1,
        title: "采购订单",
        icon: "icon-font",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
      {
        id: 22,
        path: "receipts",
        component: "inv/purchase/Receipts",
        type: 1,
        title: "采购入库",
        icon: "icon-home",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
    ],
  },
  {
    id: 30,
    path: "sales",
    component: "layout/Index",
    type: 2,
    title: "销售管理",
    icon: "icon-home",
    auth: 1,
    isLink: 0,
    isIframe: 0,
    address: "",
    isAffix: 0,
    isKeepAlive: 0,
    isDisable: 0,
    isHide: 0,
    isMobile: 0,
    roles: ["admin", "system"],
    permission: ["C", "R", "U", "D"],
    children: [
      {
        id: 31,
        path: "orders",
        component: "inv/sales/Orders",
        type: 1,
        title: "销售订单",
        icon: "icon-font",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
      {
        id: 32,
        path: "deliveries",
        component: "inv/sales/Deliveries",
        type: 1,
        title: "销售出库",
        icon: "icon-home",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
    ],
  },
  {
    id: 40,
    path: "inventory",
    component: "layout/Index",
    type: 2,
    title: "库存管理",
    icon: "icon-setting",
    auth: 1,
    isLink: 0,
    isIframe: 0,
    address: "",
    isAffix: 0,
    isKeepAlive: 0,
    isDisable: 0,
    isHide: 0,
    isMobile: 0,
    roles: ["admin", "system"],
    permission: ["C", "R", "U", "D"],
    children: [
      {
        id: 41,
        path: "stock",
        component: "inv/inventory/StockQuery",
        type: 1,
        title: "库存查询",
        icon: "icon-home",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
      {
        id: 42,
        path: "stock-takes",
        component: "inv/inventory/StockTakes",
        type: 1,
        title: "库存盘点",
        icon: "icon-font",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
      {
        id: 43,
        path: "transfers",
        component: "inv/inventory/StockTransfers",
        type: 1,
        title: "库存调拨",
        icon: "icon-home",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
    ],
  },
  {
    id: 50,
    path: "finance",
    component: "layout/Index",
    type: 2,
    title: "资金管理",
    icon: "icon-home",
    auth: 1,
    isLink: 0,
    isIframe: 0,
    address: "",
    isAffix: 0,
    isKeepAlive: 0,
    isDisable: 0,
    isHide: 0,
    isMobile: 0,
    roles: ["admin", "system"],
    permission: ["C", "R", "U", "D"],
    children: [
      {
        id: 51,
        path: "receivables",
        component: "inv/finance/Receivables",
        type: 1,
        title: "应收账款",
        icon: "icon-font",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
      {
        id: 52,
        path: "payables",
        component: "inv/finance/Payables",
        type: 1,
        title: "应付账款",
        icon: "icon-home",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
      {
        id: 53,
        path: "receipts",
        component: "inv/finance/Receipts",
        type: 1,
        title: "收款管理",
        icon: "icon-font",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
      {
        id: 54,
        path: "payments",
        component: "inv/finance/Payments",
        type: 1,
        title: "付款管理",
        icon: "icon-home",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
    ],
  },
  {
    id: 60,
    path: "reports",
    component: "layout/Index",
    type: 2,
    title: "报表分析",
    icon: "icon-home",
    auth: 1,
    isLink: 0,
    isIframe: 0,
    address: "",
    isAffix: 0,
    isKeepAlive: 0,
    isDisable: 0,
    isHide: 0,
    isMobile: 0,
    roles: ["admin", "system"],
    permission: ["C", "R", "U", "D"],
    children: [
      {
        id: 61,
        path: "inventory",
        component: "inv/reports/InventoryReport",
        type: 1,
        title: "进销存报表",
        icon: "icon-font",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
      {
        id: 62,
        path: "sales",
        component: "inv/reports/SalesReport",
        type: 1,
        title: "销售分析",
        icon: "icon-home",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
    ],
  },
  {
    id: 70,
    path: "system",
    component: "layout/Index",
    type: 2,
    title: "系统管理",
    icon: "icon-setting",
    auth: 1,
    isLink: 0,
    isIframe: 0,
    address: "",
    isAffix: 0,
    isKeepAlive: 0,
    isDisable: 0,
    isHide: 0,
    isMobile: 0,
    roles: ["admin", "system"],
    permission: ["C", "R", "U", "D"],
    children: [
      {
        id: 71,
        path: "users",
        component: "inv/system/Users",
        type: 1,
        title: "用户管理",
        icon: "icon-user",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
      {
        id: 72,
        path: "roles",
        component: "inv/system/Roles",
        type: 1,
        title: "角色管理",
        icon: "icon-font",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
      {
        id: 73,
        path: "logs",
        component: "inv/system/Logs",
        type: 1,
        title: "操作日志",
        icon: "icon-home",
        auth: 1,
        isLink: 0,
        isIframe: 0,
        address: "",
        isAffix: 0,
        isKeepAlive: 1,
        isDisable: 0,
        isHide: 0,
        isMobile: 0,
        roles: ["admin", "system"],
        permission: ["C", "R", "U", "D"],
        children: [],
      },
    ],
  },
];
